import * as React from 'react';
import { UIHeading1, ArticleParagraph2 } from '@cian/ui-kit/typography';
import { Info } from '../../Info/dump/Info';
import * as styles from './Phone.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var Phone = function Phone(_ref) {
  var phone = _ref.phone,
    name = _ref.name,
    logoUrl = _ref.logoUrl,
    workTime = _ref.workTime,
    type = _ref.type;
  return /*#__PURE__*/_jsxs("div", {
    className: styles['component'],
    "data-testid": "phone-content",
    children: [/*#__PURE__*/_jsx("div", {
      className: styles['phone'],
      children: /*#__PURE__*/_jsx(UIHeading1, {
        "data-testid": "phone",
        children: phone
      })
    }), /*#__PURE__*/_jsx("div", {
      className: styles['time'],
      children: workTime && /*#__PURE__*/_jsx(ArticleParagraph2, {
        color: "gray60_100",
        children: workTime
      })
    }), /*#__PURE__*/_jsx("div", {
      className: styles['info'],
      children: /*#__PURE__*/_jsx(Info, {
        type: type,
        name: name,
        logoUrl: logoUrl
      })
    })]
  });
};